import type { Point } from "../scene/model";
import { documentPoint, type Camera } from "../native/geometry";
import { imageMediaType } from "../native/image-formats";

/** Intercept OS file navigation, leaving the library's own upload/drop handler
 * and internal editor gestures in charge of their respective surfaces. */
export function installNativeImageDrop(
  canvas: HTMLCanvasElement,
  camera: Camera,
  insert: (files: File[], point: Point) => void,
  blocked: () => boolean,
  message: (text: string, error?: boolean) => void,
) {
  const files = (event: DragEvent) =>
    Array.from(event.dataTransfer?.types ?? []).includes("Files");
  window.addEventListener(
    "dragover",
    (event) => {
      if (!files(event)) return;
      event.preventDefault();
      if (event.target === canvas && event.dataTransfer)
        event.dataTransfer.dropEffect = blocked() ? "none" : "copy";
    },
    true,
  );
  window.addEventListener(
    "drop",
    (event) => {
      if (!files(event)) return;
      event.preventDefault();
      if (event.target !== canvas) return;
      if (blocked()) {
        message(
          "Завершите текущее действие и перенесите изображения ещё раз.",
          true,
        );
        return;
      }
      // FileList must be copied during the drop event, before the browser clears it.
      const incoming = Array.from(event.dataTransfer?.files ?? []);
      if (!incoming.length) return;
      if (incoming.some((file) => !imageMediaType(file.type, file.name))) {
        message(
          "На холст можно перенести изображения PNG, JPEG, WebP, SVG или GIF.",
          true,
        );
        return;
      }
      const box = canvas.getBoundingClientRect();
      insert(
        incoming,
        documentPoint(
          { x: event.clientX - box.left, y: event.clientY - box.top },
          camera,
        ),
      );
    },
    true,
  );
}
